'use strict';

import './plugins/plugins';
/**
 *  Load modules
 */

import './modules/ajax.js';
import './modules/main.js';
import './modules/timer.js';
import './modules/tabs.js';
import './modules/accordion.js';
import './modules/session-video.js';
import './modules/live-sessions.js';
import './modules/downloads.js';
import hoverDir from './modules/hover-dir.js';
import popup from './modules/popup.js';
import '../scss/app.scss';

(function ($) {
  $(document).ready(function () {
    hoverDir();
    popup();
  });
})(jQuery);